<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">訂單數據</span>
          </div>
          <!--div>
            <b-form-datepicker id="sell-datepicker-start" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>至</p></span>
            <b-form-datepicker id="sell-datepicker-end" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>從</p></span>
          </div-->
          <b-button-group class="ml-3 float-right">
            <b-button variant="primary" class="border" @click="setDeliverDataInterval(-7)" :class="{active:daysBeforeDeliverDataEnd===-7}">最近7天</b-button>
            <b-button variant="primary" class="border" @click="setDeliverDataInterval(-30)" :class="{active:daysBeforeDeliverDataEnd===-30}">最近30天</b-button>
            <b-button variant="primary" class="border" @click="setDeliverDataInterval(-60)" :class="{active:daysBeforeDeliverDataEnd===-60}">最近60天</b-button>
          </b-button-group>
          <b-dropdown split :split-href="deliverCaleDownloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出數據">
            <b-dropdown-item :href="deliverCaleDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="deliverCaleDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
            <b-dropdown-item :href="deliverCaleDownloadLink('json')" target="_blank">json</b-dropdown-item>
          </b-dropdown>
        </template>
        <b-card-body class="p-5">
          <b-card-group>
            <b-card class="text-center" header="已成交人數" :title="buyerCount"></b-card>
            <b-card class="text-center" header="已成交訂單筆數" :title="deliverCount"></b-card>
            <b-card class="text-center" header="已成交商品件數" :title="catalogCount"></b-card>
          </b-card-group>
          <b-card-group head-variant="light">
            <b-card class="text-center" header="銷售總額" :title="totalPrice"></b-card>
            <b-card class="text-center" header="客單價" :title="perCustomerTransaction"></b-card>
            <b-card class="text-center" header="商品瀏覽總人數" :title="catalogViewCount"></b-card>
          </b-card-group>
        </b-card-body>
      </b-card>
      <b-card header-class="custom-header-bg" class="mt-5">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">交易數據</span>
          </div>
          <!--div>
            <b-form-datepicker id="sell-datepicker-start" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>至</p></span>
            <b-form-datepicker id="sell-datepicker-end" class="ml-3 mw-15 float-right"></b-form-datepicker>
            <span class="ml-2 mt-2 float-right"><p>從</p></span>
          </div-->
          <b-button-group class="ml-3 float-right">
            <b-button variant="primary" class="border" @click="setTransactionInterval(-7)" :class="{active:daysBeforeTransactionEnd===-7}">最近7天</b-button>
            <b-button variant="primary" class="border" @click="setTransactionInterval(-30)" :class="{active:daysBeforeTransactionEnd===-30}">最近30天</b-button>
            <b-button variant="primary" class="border" @click="setTransactionInterval(-60)" :class="{active:daysBeforeTransactionEnd===-60}">最近60天</b-button>
          </b-button-group>
          <b-dropdown split :split-href="deliverPriceDownloadLink('xlsx')" variant="light" split-variant="light" class="float-right" text="匯出數據">
            <b-dropdown-item :href="deliverPriceDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
            <b-dropdown-item :href="deliverPriceDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
            <b-dropdown-item :href="deliverPriceDownloadLink('json')" target="_blank">json</b-dropdown-item>
          </b-dropdown>
        </template>
        <b-row class="mt-5">
          <b-col md="4">
            <polar-area-chart v-if="transactionChartData" :chart-data="transactionChartData"></polar-area-chart>
          </b-col>
          <b-col md="8">
            <b-table
              responsive
              :busy="isTransactionDataLoading"
              :items="transactionData"
              :fields="transactionTableFields"
              head-variant="light"
              bordered
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import QueryString from 'querystring';
import PolarAreaChart from '../../library/PolarAreaChart.js'
import { RandomRGBAColor } from '../../library/Var.js'
const backgroundColor = new Array(12).fill(null).map(() => RandomRGBAColor(0.4))
export default {
  components: {
    PolarAreaChart
  },
  data () {
    return {
      isDeliverDataLoading: false,
      analysisEnd: null,
      daysBeforeDeliverDataEnd: -7,
      isTransactionDataLoading: false,
      transactionEnd: null,
      daysBeforeTransactionEnd: -7,
      deliverData: {},
      transactionData: [],
      transactionChartData: false
    }
  },
  computed: {
    buyerCount () {
      return (this.deliverData.buyerCount || 0).toString()
    },
    deliverCount () {
      return (this.deliverData.deliverCount || 0).toString()
    },
    catalogCount () {
      return (this.deliverData.catalogCount || 0).toString()
    },
    totalPrice () {
      return (this.deliverData.totalPrice || 0).toString()
    },
    perCustomerTransaction () {
      return `$${Math.round(this.totalPrice / this.buyerCount) || 0}`
    },
    catalogViewCount () {
      return (this.deliverData.catalogViewCount || 0).toString()
    },
    deliverReqData () {
      const end = this.analysisEnd
      const start = moment(end).day(this.daysBeforeDeliverDataEnd)
      return {
        start: start.format('YYYYMMDD'),
        end: end.format('YYYYMMDD')
      }
    },
    transactionReqData () {
      const end = this.transactionEnd
      const start = moment(end).day(this.daysBeforeDeliverDataEnd)
      return {
        start: start.format('YYYYMMDD'),
        end: end.format('YYYYMMDD')
      }
    },
    transactionTableFields () {
      return [
        { key: 'name', label: '訂單金額' },
        { key: 'value', label: '訂單筆數' }
      ]
    }
  },
  methods: {
    setDeliverDataInterval (n) {
      this.analysisEnd = moment()
      this.daysBeforeDeliverDataEnd = n
      this.drawDeliverView()
    },
    async drawDeliverView () {
      /**
       * array formart
       * @type {String} id 分類ID
       * @type {String} name 分類名稱
       * @type {Number} amount 販賣累積數量
       * @type {Number} total 販賣累積金額
       */
      this.isDeliverDataLoading = true
      try {
        const query = `?${QueryString.stringify(this.deliverReqData)}`
        const { data } = await this.$api.GetDeliverCale(query)
        this.deliverData = data
      } catch (err) {
        console.log(err)
      }
      this.isDeliverDataLoading = false
    },
    setTransactionInterval (n) {
      this.transactionEnd = moment()
      this.daysBeforeTransactionEnd = n
      this.drawTransactionView()
    },
    async drawTransactionView () {
      /**
       * array format
       * @type {String} id 編號
       * @type {String} name 名稱
       * @type {Number} viewCount 查閱人數
       * @type {Number} buyerCount 購買者人數
       * @type {Number} buyAmount 總售出量
       * @type {Number} buyTotalPrice 總售出價
       */
      this.isTransactionDataLoading = true
      try {
        const query = `?${QueryString.stringify(this.transactionReqData)}`
        const { data } = await this.$api.GetDeliverPrice(query)
        const labels = Object.keys(data)
        const datasets = [{
          data: Object.values(data),
          backgroundColor
        }]
        this.transactionChartData = { labels, datasets }
        const array = []
        for (const key in data) {
          array.push({ name: key, value: data[key] })
        }
        this.transactionData = array
      } catch (err) {
        console.log(err)
      }
      this.isTransactionDataLoading = false
    },
    deliverCaleDownloadLink (format) {
      const data = { format, ...this.deliverReqData }
      const query = `?${QueryString.stringify(data)}`
      return this.$api.urlDeliverCale(query)
    },
    deliverPriceDownloadLink (format) {
      const data = { format, ...this.deliverReqData }
      const query = `?${QueryString.stringify(data)}`
      return this.$api.urlDeliverPrice(query)
    }
  },
  created () {
    this.setDeliverDataInterval(-7)
    this.setTransactionInterval(-7)
  }
}
</script>